import styled from 'styled-components';
import { Link as LinkS } from 'react-scroll';

export const ServicesContainter = styled.div`
    height: 600px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    background: #010606;
    padding: 30px;
    
    @media screen and (max-width: 768px) {
        height: 100%;    
    }

    @media screen and (max-width: 480px) {
        height: 100%;
    }
`;

export const ServicesWrapper = styled.div`
    max-width: 1000px;
    margin: 0 25px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 16px;
    padding: 0 50px;

    @media screen and (max-width: 1000px) {
        gri-template-columns: 1fr 1fr;
    }

    @media screen and (max-width: 768px) {
        grid-template-columns: 1fr;
        padding: 0 20px;
    }
`;

export const ServicesCard = styled.div`
    background: #fff;
    display: flex; 
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    border-radius: 5px;
    height: 360px;
    padding: 30px;
    box-shadow: 0 2px 4px rgba(3, 3, 3, 0.2);
    transition: all 0.2s ease-in-out;

    &:hover {
        transform: scale(1.1);
        transition: all 0.2s ease-in-out;
        cursor: pointer;
    }
`;

export const ServicesIcon = styled.img`
    height: 160px;
    width: 160px;
    margin-bottom: 10px;
`;

export const ServicesH1 = styled.h1`
    font-size: 2rem;
    color: #fff;
    margin-bottom: 64px;

    @media screen and (max-width: 480px){
        font-size: 2rem;

    }
`;

export const ServicesH2 = styled.h2`
    font-size: 1rem;
    margin-bottom: 10px;
`;

export const ServicesP = styled.p`
    font-size: 1rem;
    text-align: center;
`;

export const ServicesS = styled(LinkS)`
font-size: 16px;
outline: none;
border: none;
cursor: pointer;
transition: all 0.2s ease-in-out;
text-decoration: none;

&:hover, &:visited, &:active {
    text-decoration: none;
}`;